import mobilePageCrops from './mobilePageCrops.js';
import { getMobilePageHeight } from './mobilePageHeights.js';

const mobilePageCrop = {
  init() {
    const container = document.querySelector('.pages-container');
    if (!container) return;
    for (const definition of mobilePageCrops) {
      const page = Array.from(container.querySelectorAll('.page'))
        .find(element => element.dataset.id === String(definition.page));
      const target = page || Array.from(container.querySelectorAll('.filmstrip-track img'))
        .find(image => {
          const filename = new URL(image.src).pathname.split('/').pop();
          return filename.replace(/\.[^.]+$/, '').toLowerCase() === `LBN-Pages-${definition.page}`.toLowerCase();
        });
      if (!target) continue;
      target.style.setProperty('--mobile-page-focal-point', `${definition.x || '50%'} ${definition.y || '50%'}`);
      const scale = Number(definition.scale);
      target.style.setProperty('--mobile-page-scale', String(Number.isFinite(scale) && scale > 0 ? scale : 1));
    }
    const update = () => {
      container.style.setProperty('--mobile-page-height', `${window.innerHeight}px`);
      for (const page of container.querySelectorAll('.page:not(.filmstrip-page)')) {
        page.style.setProperty('--mobile-page-height', `${getMobilePageHeight(page.dataset.id, window.innerHeight)}px`);
        const definition = mobilePageCrops.find(entry => String(entry.page) === page.dataset.id);
        const image = page.querySelector(':scope > .page-image');
        const scaled = matchMedia('(max-width: 767px)').matches &&
          ((definition?.scale > 0 && definition.scale !== 1) || definition?.autoHeight === true);
        page.classList.toggle('page--mobile-scaled', Boolean(scaled && image));
        if (!scaled || !image) continue;
        const ratio = Number(image.getAttribute('width')) / Number(image.getAttribute('height'));
        let height = getMobilePageHeight(page.dataset.id, window.innerHeight);
        const configuredScale = Number(definition.scale);
        const scale = Number.isFinite(configuredScale) && configuredScale > 0 ? configuredScale : 1;
        const width = Math.max(page.clientWidth, Math.max(page.clientWidth, height * ratio) * scale);
        const renderedHeight = width / ratio;
        if (definition.autoHeight === true) {
          height = renderedHeight;
          page.style.setProperty('--mobile-page-height', `${height}px`);
        }
        page.style.setProperty('--mobile-crop-width', `${width}px`);
        page.style.setProperty('--mobile-crop-height', `${renderedHeight}px`);
        page.style.setProperty('--mobile-crop-left', `${(page.clientWidth - width) * parseFloat(definition.x || '50%') / 100}px`);
        page.style.setProperty('--mobile-crop-top', `${(height - renderedHeight) * parseFloat(definition.y || '50%') / 100}px`);
      }
    };
    window.addEventListener('resize', update);
    new ResizeObserver(update).observe(container);
    update();
  },
};

export default mobilePageCrop;